export const QuestionTypes = {
  RADIO: 'RADIO_BUTTON',
  CHECKBOX: 'CHECK_BOX',
  SCALE: 'SCALE',
  TEXT: 'TEXT',
  RANGE: 'RANGE',
  DROPDOWN: 'DROPDOWN',
};
